import React from 'react'

import noop from 'lodash/noop'

import cn from '../../libs/class-names'

import {CommonProps, Overwrite} from '../../types'

import checkedIcon from '../../assets/icons/checked.svg'
import minusIcon from '../../assets/icons/minus.svg'

import Icon from '../icon'

type Props = Overwrite<
  CommonProps<'div'>,
  {
    error?: boolean
    checked?: boolean
    partial?: boolean
    disabled?: boolean
    id?: string
    name?: string
    onChange?: (
      value: boolean,
      name: string | undefined,
      event: React.ChangeEvent<HTMLInputElement>
    ) => void
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void
  }
>

const CheckboxField = ({
  className,
  error = false,
  checked = false,
  partial = false,
  disabled = false,
  id,
  onChange = noop,
  onBlur,
  name,
  ...props
}: Props) => (
  <div
    {...props}
    className={cn('CheckboxField', {checked: !!checked, error, disabled}, className)}
    aria-checked={checked}
    aria-disabled={disabled}
  >
    <input
      name={name}
      id={id}
      className="CheckboxField__input"
      type="checkbox"
      onChange={event => {
        if (!disabled) {
          onChange(!checked, name, event)
        }
      }}
      onBlur={onBlur}
    />
    <div className="CheckboxField__checkedIcon">
      <Icon source={partial ? minusIcon : checkedIcon} />
    </div>
  </div>
)

export default CheckboxField
